<template>
  <svg class="e-icon" role="img">
    <use xmlns:xlink="http://www.w3.org/1999/xlink" :xlink:href="'/assets/img/common/icons.svg#' + name"></use>
  </svg>
</template>

<script>
export default {
  props: ["name"]
}
</script>



// WEBPACK FOOTER //
// src/element/icon.vue